import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { Modal } from "../../../theme/Component/Modal";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _OrderTowip, _ProductionOrderDocuments } from "../../../../core/services/dataBean/EntityCatalogVdos";

interface Props {
    idProductionOrder: any;
    productionOrderDate: any;
}

export const ProductionOrderDocuments = ({ idProductionOrder, productionOrderDate }: Props) => {

    const Documents = useDataBean(_ProductionOrderDocuments);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        Documents.instance.getProductionOrderDocuments(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    // let x = resp;
                    // x.forEach((user) => {

                    //     user.DataBeanProperties.Doc = (user.DataBeanProperties.Mnemonic ?? "") + "-" + (user.DataBeanProperties.Consecutive ?? "") + "-" + (user.DataBeanProperties.DocumentDate ?? "");

                    // });
                    setLista(resp)
                }
            }
        )

    }


    const create = () => {
        Documents.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        Documents.deleteItemVoid(Documents.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        Documents.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
    ]
    const verDocumentos = () => {

        if (Documents.bean) {
            _documentos.instance.getPdfAccountantDocument(Documents.bean.IDDocument, null, Documents.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModalverdoc({ ...modalverdoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <BasicPage titulo="Ver Documentos de la Orden de Producción">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={Documents.setBean} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} >
                        <div className="row">

                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={Documents.bean.Code} onChange={Documents.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={Documents.bean.Name} onChange={Documents.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">

                            <DocumentViewer
                                list={docs}
                                IDDocument={Documents.bean.IDDocument}
                                Since={Documents.bean.DocumentDate}
                            />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {Documents.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}